<mat-icon class="favorite-star"
    [ngClass]="{'material-symbols-outlined': !hasFavorites(), 'filled': hasFavorites()}"
    [matMenuTriggerFor]="menu">star</mat-icon>

<mat-menu #menu="matMenu">
    <div (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()">
        <div class="favorites__container">
            <div class="header">
                <div class="title">
                    {{ 'default.favorites.addToList' | blah }}
                </div>
                <div>
                    <button class="add-button"
                        [disabled]="createNewListElement"
                        (click)="createNewList()">
                        <mat-icon>add</mat-icon>
                        {{ 'default.favorites.createNewList' | blah }}
                    </button>
                </div>
            </div>
            @if (createNewListElement || favoriteLists.length) {
                <div class="favorite-lists__container">
                    @if (createNewListElement) {
                        <div class="add-new-list-element__container">
                            <mat-checkbox [checked]="true"
                                [disabled]="true">
                            </mat-checkbox>
                            <input type="text"
                                id="new-list-element-input"
                                placeholder="{{ 'default.favorites.newListName' | blah }}"
                                (keydown.enter)="createUserFavoriteList(true)"
                                #newListElementInput>
                            <mat-icon (click)="createUserFavoriteList(false)"
                                id="cancelAddNewListElement">
                                close
                            </mat-icon>
                            <mat-icon (click)="createUserFavoriteList(true)"
                                id="confirmAddNewListElement">
                                check
                            </mat-icon>
                        </div>
                    }
                    @if (favoriteLists.length) {
                        @for (list of favoriteLists; track list) {
                            <mat-checkbox [checked]="list.selected"
                                [disabled]="createNewListElement"
                                (change)="handleSelectList($event, list)">
                                <span>{{list.Name}}</span>
                            </mat-checkbox>
                        }
                    }
                </div>
            }
        </div>
    </div>
</mat-menu>